import React from 'react';
import { CheckIcon } from '@heroicons/react/24/solid';
import { getWorkflowSteps, getStepState, STAGE_DOT } from '../utils/requestStatus';

/**
 * Frise horizontale d'avancement du workflow.
 * - étape franchie : vert + coche
 * - étape en cours : couleur de l'étape
 * - étape refusée : rouge
 * - étape à venir : gris
 */
const WorkflowStepper = ({ workflowType, sourceCategory, currentStage, status, requestType, circuitTerrain }) => {
  const steps = getWorkflowSteps(workflowType, sourceCategory, requestType, currentStage, circuitTerrain);

  return (
    <div className="bg-white rounded-lg shadow p-6 mb-6">
      <h2 className="text-lg font-semibold mb-4">Avancement</h2>
      <ol className="flex items-start">
        {steps.map((step, idx) => {
          const state = getStepState(step.key, steps, currentStage, status);
          const isLast = idx === steps.length - 1;

          const dotClasses =
            state === 'done' ? 'bg-green-500 text-white'
              : state === 'rejected' ? 'bg-red-500 text-white'
                : state === 'current' ? `${STAGE_DOT[step.key] || 'bg-blue-500'} text-white`
                  : 'bg-gray-200 text-gray-500';

          const labelClasses =
            state === 'upcoming' ? 'text-gray-400'
              : state === 'rejected' ? 'text-red-600 font-medium'
                : 'text-gray-700 font-medium';

          const connectorClasses = state === 'done' ? 'bg-green-500' : 'bg-gray-200';

          return (
            <li key={step.key} className="flex-1 flex flex-col items-center relative">
              {!isLast && (
                <span
                  className={`absolute top-4 left-1/2 w-full h-0.5 ${connectorClasses}`}
                  aria-hidden="true"
                />
              )}
              <span
                className={`relative z-10 flex items-center justify-center h-8 w-8 rounded-full text-xs font-semibold ${dotClasses}`}
              >
                {state === 'done' ? <CheckIcon className="h-4 w-4" /> : idx + 1}
              </span>
              <span className={`mt-2 text-xs text-center px-1 ${labelClasses}`}>{step.label}</span>
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default WorkflowStepper;
